import { FETCH_ALL_USER_ACTIVITY, FETCH_ALL_USER_ACTIVITY_SUCCESS } from "../ActionTypes"

// fetching all user activity
export const fetchAllUserActivity = id => ({
    type: FETCH_ALL_USER_ACTIVITY,
    payload:id
  })


export const fetchAllUserActivitySuccess = payload => ({
  type: FETCH_ALL_USER_ACTIVITY_SUCCESS,
  payload
})
